/**
 * Format a byte count the way the upload field already displays it.
 *
 * ⚠ This deliberately mirrors Vuetify's own `humanReadableFileSize`
 * (vuetify/lib/util/helpers.js:254) rather than picking its own scheme. The
 * `<v-file-input>` in EntityMaskForm.vue sets `show-size` and `counter`, so
 * Vuetify prints the picked file's size right next to the field. `show-size` is
 * passed as a boolean, which leaves Vuetify's `base` argument undefined and so
 * falls to its default of 1000 -- decimal units with a lowercase `k`
 * ("9.5 MB", "12.3 kB"), NOT binary ones.
 *
 * A validation message that disagreed with the size printed two lines above it
 * ("this file is 10.0 MB" beside a field reading "9.5 MiB") would read as a bug.
 * Matching the algorithm exactly is the point.
 */
export function formatBytes(bytes: number): string {
  if (!Number.isFinite(bytes)) {
    return ''
  }
  const base = 1000
  if (Math.abs(bytes) < base) {
    return `${bytes} B`
  }
  const prefix = ['k', 'M', 'G']
  let scaled = bytes
  let unit = -1
  while (Math.abs(scaled) >= base && unit < prefix.length - 1) {
    scaled /= base
    ++unit
  }
  return `${scaled.toFixed(1)} ${prefix[unit]}B`
}
